"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateCalculation = void 0;
const enums_1 = require("../../enums");
const validateCalculation = (calculation) => {
    let missing = [];
    if (!calculation)
        missing.push(enums_1.OrderValidation.MissingOffer);
    return Array.from(new Set(missing));
};
exports.validateCalculation = validateCalculation;
//# sourceMappingURL=calculation.js.map